<template>
    <vs-prompt :color="color" :active.sync="activePromptLocal" :acceptText="acceptText" :cancelText="null" class="custom-prompt" :class="classList" :title="titleLocal" @accept="accept">
        <slot name="content"></slot>
    </vs-prompt>
</template>

<script>
// import 
export default {
    name: "CustomPrompt",
    props: {
        type: {
            type: String,
            default: 'success'
        },
        color: {
            type: String,
            default: 'primary'
        },
        activePrompt: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "",
        },
        // content: {
        //     type: String,
        //     default: "",
        // },
        classList: {
            type: String,
            default: ""
        },
        acceptText: {
            type: String,
            default: "Okay"
        },
        accept: {
            type: Function,
            default: () => {
                return true;
            }
        }
    },
    data() {
        return {
            activePromptLocal: false
        }
    },
    watch: {
        activePrompt() {
            this.activePromptLocal = this.activePrompt;
        },
        activePromptLocal() {
            this.$emit('update:activePrompt', this.activePromptLocal);
        }
    },
    computed: {
        titleLocal() {
            if(this.type == 'error') {
                return 'Error'
            }

            return this.title;
        },
    },
};
</script>